/**
 * List of error message patterns to ignore in Sentry (expected errors)
 * Shared between backend and frontend
 *
 * Add exact message matches here. Both client and server will filter these out.
 */
export const IGNORED_ERROR_MESSAGES = [
    // Backend errors
    'POST /api/authenticate 401',  // Wrong password attempts
    'GET /api/buyers/budget/get-remaining 401',  // SEL-1202: expired/absent buyer session hitting dashboard (not logged in)
    'GET /api/buyers/budget/get-remaining 405',  // SEL-1202: 405 == TOKEN_EXPIRED here (expired token), not "method not allowed"

    // Frontend errors
    'Request failed with status code 401',  // Axios 401 errors (login failures, expired sessions)

    // Add more patterns here as needed:
    // 'ChunkLoadError',  // Old cached code after deployments
    // 'ResizeObserver loop',  // Common browser quirk
    // 'GET /api/some-endpoint 404',
    // 'PUT /api/another-endpoint 403',
];
